// extracted by mini-css-extract-plugin
export var active = "_99-7";
export var container = "_99-0";
export var evenWidth = "_99-4";
export var large = "_99-5";
export var outlet = "_99-8";
export var slide = "_99-2";
export var small = "_99-6";
export var tab = "_99-3";
export var tabs = "_99-1";